/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timezone_Europe_London2Inputs */

const he_timezone_europe_london2 = /** @type {(inputs: Timezone_Europe_London2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`London`)
};

const en_timezone_europe_london2 = /** @type {(inputs: Timezone_Europe_London2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`London`)
};

/**
* | output |
* | --- |
* | "London" |
*
* @param {Timezone_Europe_London2Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const timezone_europe_london2 = /** @type {((inputs?: Timezone_Europe_London2Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timezone_Europe_London2Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_timezone_europe_london2(inputs)
	return en_timezone_europe_london2(inputs)
});
export { timezone_europe_london2 as "timezone_Europe_London" }